var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"splash"}},[_c('div',{attrs:{"id":"splash-wait"}},[_vm._v(_vm._s(_vm.message))]),_c('div',{attrs:{"id":"splash-loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }